module.exports = __webpack_public_path__ + "static/media/logo.7b5d3d53.png";